import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardAt20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconClipboardAt20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 2.75h5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-5A.25.25 0 0 1 7.25 4V3a.25.25 0 0 1 .25-.25M5.75 3c0-.967.784-1.75 1.75-1.75h5c.967 0 1.75.783 1.75 1.75h.25A2.5 2.5 0 0 1 17 5.5v1.645a5.3 5.3 0 0 0-1.5-.836V5.5a1 1 0 0 0-1-1h-.322A1.75 1.75 0 0 1 12.5 5.75h-5A1.75 1.75 0 0 1 5.823 4.5H5.5a1 1 0 0 0-1 1v10a1 1 0 0 0 .802.98A5.3 5.3 0 0 0 6.145 18H5.5A2.5 2.5 0 0 1 3 15.5v-10A2.5 2.5 0 0 1 5.5 3zM12 14.5c.308 0 1-.404 1-1.5s-.692-1.5-1-1.5-1 .404-1 1.5.692 1.5 1 1.5m1.275-4.08A2.2 2.2 0 0 0 12 10c-1.38 0-2.5 1.343-2.5 3s1.12 3 2.5 3c.563 0 1.083-.223 1.5-.6.254.218.583.35.944.35h1.168a2.14 2.14 0 0 0 2.138-2.137v-1.45c0-2.714-2.2-4.913-4.912-4.913h-1.676a4.91 4.91 0 0 0-4.912 4.912v1.676c0 2.713 2.2 4.912 4.912 4.912H17a.75.75 0 0 0 0-1.5h-5.838a3.41 3.41 0 0 1-3.412-3.412v-1.676a3.41 3.41 0 0 1 3.412-3.412h1.676a3.41 3.41 0 0 1 3.412 3.412v1.45a.637.637 0 0 1-.637.638H14.5V11a.75.75 0 0 0-1.225-.58"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardAt20);
